/**
 * @fileoverview GET handler for the "/apps/api_dashboard/query" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsApiDashboardQuery } from "./constants";
import type { AppsApiDashboardQueryResult } from "./types";
import type { GetAppsApiDashboardQueryParams } from "./types";

export const getAppsApiDashboardQuery = reactQueryFetcherAdapter(
  appsApiDashboardQuery,
  (signal: AbortSignal, params: GetAppsApiDashboardQueryParams): Promise<AppsApiDashboardQueryResult> => {
    return fetch(
      "/apps/api_dashboard/query",
      "GET",
      params,
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
